module.exports = __webpack_public_path__ + "static/media/detailedGreyhoundWhite.53cb6096.svg";